import { SVGProps } from 'react'

function SvgMastercard(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={70}
      height={48}
      viewBox="0 0 70 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <title>Mastercard</title>
      <path
        d="M0 6a6 6 0 0 1 6-6h58a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 1H6a5 5 0 0 0-5 5v36a5 5 0 0 0 5 5h58a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5ZM6 0a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h58a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Z"
        fill="#788BA5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.5 34.314a13.502 13.502 0 0 1-8.852 3.298C19.11 37.612 13 31.43 13 23.806 13 16.181 19.11 10 26.648 10c3.378 0 6.469 1.242 8.852 3.298A13.502 13.502 0 0 1 44.352 10C51.89 10 58 16.181 58 23.806c0 7.625-6.11 13.806-13.648 13.806-3.377 0-6.469-1.242-8.852-3.298Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.5 34.314a13.841 13.841 0 0 0 4.795-10.508A13.84 13.84 0 0 0 35.5 13.298 13.502 13.502 0 0 1 44.352 10C51.89 10 58 16.181 58 23.806c0 7.625-6.11 13.806-13.648 13.806-3.377 0-6.469-1.242-8.852-3.298Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.5 13.298a13.841 13.841 0 0 1 4.795 10.508c0 4.208-1.86 7.976-4.795 10.508a13.841 13.841 0 0 1-4.795-10.508c0-4.208 1.86-7.976 4.795-10.508Z"
        fill="#FF5E00"
      />
    </svg>
  )
}
export default SvgMastercard
